import styled, { css } from 'styled-components';

import { Horizontal, Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyM, BodyS, LabelS } from '@sorare/core/src/atoms/typography';
import { useAmountWithConversion } from '@sorare/core/src/hooks/useAmountWithConversion';
import type { MonetaryAmountParams } from '@sorare/core/src/lib/monetaryAmount';
import { MonetaryAmount } from '@sorare/core/src/lib/monetaryAmount';

const Prices = styled(Horizontal)`
  align-items: flex-end;
  text-align: right;
`;
const Row = styled(Horizontal)<{ $column?: boolean }>`
  justify-content: flex-end;
  align-items: baseline;
  ${({ $column }) =>
    $column
      ? css`
          align-items: flex-end;
          flex-direction: column-reverse;
        `
      : ''};
`;

const Price = ({
  monetaryAmount,
  column,
  small,
}: {
  monetaryAmount: Nullable<MonetaryAmountParams>;
  column?: boolean;
  small?: boolean;
}) => {
  const { main, exponent } = useAmountWithConversion({
    monetaryAmount: monetaryAmount || MonetaryAmount.zero,
  });
  if (!monetaryAmount) return null;

  return (
    <Row gap={small ? 0 : 0.5} $column={column}>
      {!!exponent && <LabelS color="var(--c-nd-600)">{exponent}</LabelS>}
      {small ? <BodyS bold>{main}</BodyS> : <BodyM bold>{main}</BodyM>}
    </Row>
  );
};

type Props = {
  monetaryAmount: MonetaryAmountParams;
  column?: boolean;
  small?: boolean;
};

export const StartingPrice = ({
  monetaryAmount,
  column,
  small = false,
}: Props) => {
  return (
    <Prices gap={small ? 0.5 : 2}>
      <Vertical gap={0.5}>
        <Price monetaryAmount={monetaryAmount} small={small} column={column} />
      </Vertical>
    </Prices>
  );
};
